import { IconGear } from '@posthog/icons';
import * as React from 'react';
export default {
  IconGear,
  React
};